import { createBrowserHistory } from 'history'
import { getBranchPrefix } from './branchDeploy'

const history = createBrowserHistory({ basename: getBranchPrefix() ?? '' })

// @ts-ignore - provided for playwright
window.reactRouterHistory = history

export default history
